<template>
  <div class="table">
    <table>
      <thead>
        <tr>
          <th
            v-for="({ labelKey }, index) in headers"
            :key="index"
          >
            {{ $t(`table.header.${labelKey}`) }}
          </th>
          <th v-if="hasUpdateTrRepAccess" />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(user, index) in accounts"
          :key="user.id"
        >
          <td
            v-for="({ valueKey }) in headers"
            :key="`${valueKey}_${index}`"
          >
            {{ user[valueKey] | isEmptyValue }}
          </td>
          <td v-if="hasUpdateTrRepAccess"><HKLButton
            color="orange"
            action="invite"
            @click="() => inviteUser(user.accountId)"
          /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { unref } from 'vue-demi'
import { inviteTrRepAccounts } from '@/api/tenancies/request'
import HKLButton from '@/controls/Button/HKLButton.vue'
import { useRouteParamId } from '@/router/useRouter'
import { hasUpdateTrRepAccess, useHeaderCols, useTrRepAccounts } from './hook'

export default {
  components: {
    HKLButton,
  },
  setup () {
    const headers = useHeaderCols()
    const tenancyId = useRouteParamId()
    const { accounts, refresh } = useTrRepAccounts(tenancyId)
    const inviteUser = async (accountId) => {
      await inviteTrRepAccounts(unref(tenancyId), unref(accountId))
      await refresh()
    }
    return {
      accounts,
      hasUpdateTrRepAccess,
      headers,
      inviteUser,
    }
  },
}
</script>
